import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-simple-icon',
  templateUrl: './alert-simple-icon.component.html',
  styles: [
  ]
})
export class AlertSimpleIconComponent {

}
